import getters from "@/store/modules/skills/getters";
export default {
    namespaced: true,
    state(){
        return {
            skills:['spring','apache','sass','ssh','tomcat','ubuntu','vuejs','woocommerce','wordpress','php'
                ,'photoshop','oracle','numpy','nginx','nodejs','mysql','moodle','mongodb','matlab','linux',
                'javascript','java','html5','googlecloud','git','github','firebase','express','debian','css3',
                'csharp','cplusplus','c','bootstrap','arduino',]
        }
    },
    getters,

}